"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convert_data = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var normalize_name = function normalize_name(name) {
  var new_name = name.split('\\n').join('').split(' ').join('');
  return new_name;
};

var convert_data = function convert_data(data_to_convert) {
  var data = data_to_convert;
  console.log('FUNCTION : convert_data');

  if (!data.display_style) {
    data.display_style = {};
  }

  if (data_to_convert.tags_catalog === undefined) {
    data_to_convert.tags_catalog = {};
  } // if (data_to_convert.colorFavoriteTags === undefined) {
  //   data_to_convert.colorFavoriteTags = {}
  // }


  if (Array.isArray(data.tags_catalog)) {
    data_to_convert.tags_catalog = Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2.default)(data.tags_catalog.map(function (tags_group) {
      return (0, _defineProperty2.default)({}, tags_group.group_name, {
        group_name: tags_group.group_name,
        show_legend: tags_group.show_legend,
        tags: Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2.default)(tags_group.tags.map(function (tag_name) {
          return (0, _defineProperty2.default)({}, tag_name, {
            name: tag_name,
            color: '',
            selected: tags_group.selected_tags.includes(tag_name)
          });
        })))),
        banner: tags_group.group_name === 'Regions' || tags_group.group_name === 'Periods' || tags_group.group_name === 'dimension' ? 'one' : 'multi'
      });
    }))));
  }

  Object.values(data_to_convert.tags_catalog).forEach(function (tags_group) {
    Object.values(tags_group.tags).forEach(function (tag) {
      return tag.selected = Boolean(tag.selected);
    });

    if (tags_group.show_legend === undefined) {
      tags_group.show_legend = false;
    }
  });

  if (data_to_convert.tags_catalog['flux_types']) {
    data_to_convert.tags_catalog['flux_types'].group_name = 'Type de donnée';
    data_to_convert.tags_catalog['flux_types'].tags['initial_data'].name = 'Données collectées';
    data_to_convert.tags_catalog['flux_types'].tags['adjusted_data'].name = 'Données réconciliées';
    data_to_convert.tags_catalog['flux_types'].tags['computed_data'].name = 'Données déterminées';
  }

  if (data_to_convert.tags_catalog['SubChain']) {
    data_to_convert.tags_catalog['SubChain'].group_name = 'Sous-Filières';
  }

  if (data_to_convert.tags_catalog['Exchanges']) {
    data_to_convert.tags_catalog['Exchanges'].group_name = 'Echanges';
  }

  if (!Array.isArray(data.links) && data.version !== '0.5') {
    var key_names = Object.keys(data.links);
    var new_links = JSON.parse(JSON.stringify(data.links[key_names[0]]));
    new_links.forEach(function (link, i) {
      link.value = [];
      link.display_value = [];
      var convert_link = link;

      if (convert_link.mini !== undefined && convert_link.maxi !== undefined) {
        convert_link.mini = [];
        convert_link.maxi = [];
      }

      if (convert_link.data_value !== undefined) {
        convert_link.data_value = [];
      }

      if (convert_link.data_source !== undefined) {
        convert_link.data_source = [];
      }

      if (convert_link.data_period !== undefined) {
        convert_link.data_period = [];
      }

      key_names.forEach(function (cur_key_name) {
        link.value.push(data.links[cur_key_name][i].value);
        link.display_value.push(data.links[cur_key_name][i].display_value);

        if (convert_link.mini !== undefined && convert_link.maxi !== undefined) {
          convert_link.mini.push(data.links[cur_key_name][i].mini);
          convert_link.maxi.push(data.links[cur_key_name][i].maxi);
        }

        if (convert_link.data_value !== undefined) {
          convert_link.data_value.push(data.links[cur_key_name][i].data_value);
        }

        if (convert_link.data_source !== undefined) {
          convert_link.data_source.push(data.links[cur_key_name][i].data_source);
        }

        if (convert_link.data_period !== undefined) {
          convert_link.data_period.push(data.links[cur_key_name][i].data_period);
        }
      });
    });
    new_links.forEach(function (l, i) {
      return l.idLink = 'link' + i;
    });
    data_to_convert.links = Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2.default)(new_links.map(function (l) {
      return (0, _defineProperty2.default)({}, l.idLink, (0, _objectSpread2.default)({}, l));
    }))));
    data_to_convert.nodes.forEach(function (n, i) {
      return n.idNode = 'node' + i;
    });
    data_to_convert.nodes = Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2.default)(data_to_convert.nodes.map(function (n) {
      return (0, _defineProperty2.default)({}, n.idNode, (0, _objectSpread2.default)({}, n));
    }))));

    if (key_names.length > 1 && !data.periods && data.region_names) {
      data.tags_catalog['Regions'] = {
        group_name: 'Regions',
        show_legend: false,
        tags: Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2.default)(data.region_names.map(function (region_name) {
          return (0, _defineProperty2.default)({}, region_name, {
            name: region_name,
            color: '',
            selected: region_name === data.region_name
          });
        })))),
        banner: 'one'
      };
    }

    if (key_names.length > 1 && data.periods) {
      data.tags_catalog['Periods'] = {
        group_name: 'Periods',
        show_legend: false,
        tags: Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2.default)(key_names.map(function (key_name) {
          return (0, _defineProperty2.default)({}, key_name, {
            name: key_name,
            color: '',
            selected: key_names[0]
          });
        })))),
        banner: 'one'
      };
    }

    delete data.periods;
    delete data.region_names;
    delete data.region_name;
  }

  if (Array.isArray(data.links) && (data.version === '0.5' || data.version === '0.4')) {
    if (data.links.length > 0 && !data.links[0].idLink) {
      data.links.forEach(function (l, i) {
        return l.idLink = 'link' + i;
      });
    }

    if (data.nodes.length > 0 && !data.nodes[0].idNode) {
      data.nodes.forEach(function (n) {
        return n.idNode = 'node' + n.id;
      });
    }

    data_to_convert.links = Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2.default)(data.links.map(function (l) {
      return (0, _defineProperty2.default)({}, l.idLink, (0, _objectSpread2.default)({}, l));
    }))));
    data_to_convert.nodes = Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2.default)(data.nodes.map(function (n) {
      return (0, _defineProperty2.default)({}, n.idNode, (0, _objectSpread2.default)({}, n));
    }))));
  }

  if (Object.keys(data.links).length > 0 && !Object.values(data.links)[0].idLink) {
    Object.values(data.links).forEach(function (l, i) {
      return l.idLink = 'link' + i;
    });
  }

  if (Object.keys(data.nodes).length > 0 && !Object.values(data.nodes)[0].idNode) {
    Object.values(data.nodes).forEach(function (n) {
      return n.idNode = 'node' + n.id;
    });
  }

  Object.values(data.links).forEach(function (l) {
    if (l.source_name) {
      var source_node = Object.values(data.nodes).filter(function (n) {
        return normalize_name(n.name) === normalize_name(l.source_name);
      })[0];
      var target_node = Object.values(data.nodes).filter(function (n) {
        return normalize_name(n.name) === normalize_name(l.target_name);
      })[0];
      l.idSource = source_node.idNode;
      l.idTarget = target_node.idNode;
      delete l.source_name;
      delete l.target_name;
    }
  });

  if (!data_to_convert.tags_catalog) {
    data_to_convert.tags_catalog = {};
  }

  Object.values(data.nodes).forEach(function (n) {
    if (n.input_links) {
      n.inputLinksId = [];
      n.outputLinksId = [];
      n.input_links.forEach(function (link_idx) {
        n.inputLinksId.push(data.links['link' + link_idx].idLink);
      });
      n.output_links.forEach(function (link_idx) {
        n.outputLinksId.push(data.links['link' + link_idx].idLink);
      });
      delete n.output_links;
      delete n.input_links;
      delete n.id;
    }
  });
  Object.values(data.nodes).forEach(function (n) {
    if (!n.inputLinksId) {
      n.inputLinksId = [];
    }

    if (!n.outputLinksId) {
      n.outputLinksId = [];
    }
  });
  var display_style = data.display_style,
      nodes = data.nodes,
      links = data.links,
      node_width = data.node_width,
      units_names = data.units_names;

  if (display_style.filter === undefined) {
    display_style.filter = 0;
  }

  if (display_style.global_curvature === undefined) {
    display_style.global_curvature = 0.99;
  }

  if (display_style.trade_close === undefined && (data.version === '0.2' || data.version === '0.3')) {
    display_style.trade_close = true;
  }

  if (data.version === '0.1') {
    display_style.sector_uppercase = true;
    display_style.sector_bold = true;
    display_style.trade_close = false;

    if (node_width === undefined) {
      data.node_width = 40;
    }

    data.show_uncert = false;
  }

  if (data.version === '0.2') {
    display_style.sector_uppercase = true;
    display_style.sector_bold = true;

    if (node_width === undefined) {
      data.node_width = 40;
    }

    data.show_uncert = false;
  }

  if (data.version === '0.3') {
    data.show_uncert = false;
  }

  if (data.display_style.unit === 1) {
    data.display_style.unit = true;
  }

  if (data.node_width === undefined) {
    data.node_width = 10;
  }

  if (data.display_style.null_flux === undefined) {
    data.display_style.null_flux = false;
  }

  if (data.h_space === undefined) {
    data.h_space = 200;
  }

  if (data.v_space === undefined) {
    data.v_space = 100;
  }

  if (data.trade_hspace === undefined) {
    data.trade_hspace = 200;
  }

  if (data.left_shift === undefined) {
    data.left_shift = 0.4;
  }

  if (data.right_shift === undefined) {
    data.right_shift = 0.5;
  }

  if (data.trade_close_hspace === undefined) {
    data.trade_close_hspace = 50;
  }

  if (data.trade_close_vspace === undefined) {
    data.trade_close_vspace = 20;
  }

  if (data.legend_position === undefined) {
    data.legend_position = [0, 100];
  }

  var attributes_to_remove = ['previous_filter', 'filtered_links', 'filtered_nodes_names', 'filtered_nodes', 'nodes_names', 'max_vertical_offset', 'error', 'nodes2units_conv', 'nodes2tooltips'];

  for (var attr in attributes_to_remove) {
    if (attributes_to_remove[attr] in data) {
      delete data[attributes_to_remove[attr]];
    }
  }

  var import_export = false;
  var subchains = [];
  Object.values(nodes).forEach(function (n) {
    var n_convert = n;

    if (!n.tags) {
      n.tags = {};
    }

    if (n_convert.subchain && n_convert.subchain !== '') {
      n.tags['SubChain'] = n_convert.subchain.split(',');
      n_convert.subchain.split(',').forEach(function (s) {
        if (!subchains.includes(s)) {
          subchains.push(s);
        }
      });
      delete n_convert.subchain;
    }

    if (n.x === undefined) {
      n.x = 0;
    }

    if (n.y === undefined) {
      n.y = 0;
    }

    if (n_convert.visible === undefined && !n.node_visible && data.version !== '0.5') {
      n.shape_visible = true;
    }

    if (n_convert.visible === 1) {
      n.shape_visible = true;
    }

    if (n_convert.visible === 0) {
      n.shape_visible = false;
    }

    if (n_convert.show_value === 0 || n_convert.show_value === undefined) {
      n.show_value = false;
    }

    if (n_convert.show_value === 1) {
      n.show_value = true;
    }

    if (n_convert.label_visible === 1) {
      n.label_visible = true;
    }

    if (n_convert.label_visible === 0) {
      n.label_visible = false;
    }

    if (n.label_visible === undefined || n_convert.label_visible === 1) {
      n.label_visible = true;
    }

    if (n.shape_visible === undefined || n_convert.shape_visible === 1) {
      n.shape_visible = true;
    }

    if (n.node_parameter === undefined) {
      n.node_parameter = 'general';
    }

    delete n_convert.visible;

    if (n.node_visible === undefined) {
      n.node_visible = n.shape_visible || n.label_visible;
    }

    if (n_convert.node_visible === 1) {
      n.node_visible = true;
    }

    if (n_convert.display === 1) {
      n.display = true;
    }

    if (n_convert.display === 0) {
      n.display = false;
    }

    if (n.display === undefined) {
      n.display = true;
    }

    if (n.tag_favorite === undefined) {
      n.tag_favorite = {};
    }

    delete n_convert.visible;
    n.name = n.name.split('\\n').join(' ');
    var attributes_to_remove = ['tooltips', 'total_input_offset', 'input_offsets', 'total_output_offset', 'output_offsets', 'horizontal_index', 'title_length', 'old_color'];

    for (var _attr in attributes_to_remove) {
      if (attributes_to_remove[_attr] in n_convert) {
        delete n_convert[attributes_to_remove[_attr]];
      }
    }

    if (n.name.includes('(I') && n.outputLinksId.length > 0) {
      import_export = true;
      n.node_visible = true;
      n.tags['Exchanges'] = ['import'];
      var l = links[n.outputLinksId[0]];

      if (!l.tags) {
        l.tags = {};
      }

      l.tags['Exchanges'] = ['import'];

      if (data.display_style.trade_close !== undefined) {
        n_convert.trade_close = data.display_style.trade_close;
      }
    } else if (n.name.includes('(E')) {
      import_export = true;
      n.node_visible = true;
      n.tags['Exchanges'] = ['export'];
      var _l = links[n.inputLinksId[0]];

      if (!_l.tags) {
        _l.tags = {};
      }

      _l.tags['Exchanges'] = ['export'];

      if (data.display_style.trade_close !== undefined) {
        n_convert.trade_close = data.display_style.trade_close;
      }
    } //else if (!n.tags['Exchanges']) {
    //   n.tags['Exchanges'] = ['Other']
    // }

  });

  if ('trade_close' in data.display_style) {
    delete data.display_style.trade_close;
  }

  if (import_export) {
    // if (data.tags_catalog.filter(tag => tag.group_name === 'Exchanges').length === 0) {
    //   data.tags_catalog.push({
    //     group_name: 'Exchanges',
    //     tags: ['Importations', 'Exportations', 'Other'],
    //     selected_tags: ['Importations', 'Exportations', 'Other']
    //   })
    // }
    //TC v2
    if (Object.entries(data.tags_catalog).filter(function (tag) {
      return tag[0] === 'Exchanges';
    }).length === 0) {
      data.tags_catalog['Exchanges'] = {
        group_name: 'Echanges',
        show_legend: false,
        tags: {
          'import': {
            name: 'Importations',
            selected: true
          },
          'export': {
            name: 'Exportations',
            selected: true
          },
          'Other': {
            name: 'Other',
            selected: true
          }
        },
        banner: 'multi'
      };
    }
  }

  if (data.subchains && data.subchains[0] !== '') {
    var cpySbchaine = data.subchains;

    if (Object.entries(data.tags_catalog).filter(function (tags_group) {
      return tags_group[0] === 'SubChain';
    }).length === 0) {
      var tags_dict = Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2.default)(cpySbchaine.map(function (subchain) {
        return (0, _defineProperty2.default)({}, subchain, {
          name: subchain,
          color: 'red',
          selected: true
        });
      }))));
      data.tags_catalog['SubChain'] = {
        group_name: 'Sous-Filières',
        show_legend: false,
        tags: tags_dict,
        banner: 'multi'
      };
      delete data.subchains;
    }
  } else if (subchains.length > 0) {
    var _tags_dict = Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2.default)(subchains.map(function (subchain) {
      return (0, _defineProperty2.default)({}, subchain, {
        name: subchain,
        color: 'red',
        selected: true
      });
    }))));

    if (Object.entries(data.tags_catalog).filter(function (tags_group) {
      return tags_group[0] === 'SubChain';
    }).length === 0) {
      data.tags_catalog['SubChain'] = {
        group_name: 'Sous-Filières',
        show_legend: false,
        tags: _tags_dict,
        banner: 'multi'
      };
    }
  }

  if (data.flux_types || data.use_flux_types) {
    if (!data.tags_catalog['flux_types']) {
      data.tags_catalog['flux_types'] = {
        group_name: 'Type de donnée',
        show_legend: false,
        tags: {
          'initial_data': {
            name: 'Données collectées',
            selected: false
          },
          'computed_data': {
            name: 'Données déterminées',
            selected: true
          },
          'adjusted_data': {
            name: 'Données réconciliées',
            selected: true
          }
        },
        banner: 'multi'
      };
      delete data.flux_types;
      delete data.use_flux_types;
    }
  }

  var flux_max = 0;
  Object.values(links).forEach(function (l) {
    var l_convert = l;
    l.value.forEach(function (v) {
      v = +v;

      if (flux_max < v) {
        flux_max = v;
      }
    });
    var source_node = nodes[l.idSource];
    var target_node = nodes[l.idTarget];

    if (!source_node || !target_node) {
      return;
    }

    if (l.label_visible === undefined) {
      l.label_visible = true;
    }

    if (l.color === undefined) {
      l.color = source_node.color;
    }

    if (!l.tags) {
      l.tags = {};
    }

    if (l.shift_gap === undefined) {
      if (l.left_horiz_shift && l.right_horiz_shift && !l.recycling) {
        l.shift_gap = (l.right_horiz_shift - l.left_horiz_shift) / 2;
      } else {
        l.shift_gap = 0.1;
      }
    }

    if (l_convert.subchain && l_convert.subchain !== '') {
      l.tags['SubChain'] = l_convert.subchain.split(',');
      l_convert.subchain.split(',').forEach(function (s) {
        if (!subchains.includes(s)) {
          subchains.push(s);
        }
      });
      delete l_convert.subchain;
    }

    if (!('orientation' in l)) {
      l.orientation = 'hh';

      if (source_node.orientation === 'horizontal' && target_node.orientation === 'vertical') {
        l.orientation = 'vh';
      } else if (source_node.orientation === 'vertical' && target_node.orientation === 'horizontal') {
        l.orientation = 'hv';
      }
    }

    if (!('display_value' in l)) {
      l.display_value = ['default'];
    }

    if (!('arrow' in l)) {
      l.arrow = true;
    }

    if (!('curved' in l)) {
      l.curved = true;
    }

    if (!('label_on_path' in l)) {
      l.label_on_path = true;
    }

    if (l_convert.frozen) {
      l.label_position = 'frozen';
    }

    if ('frozen' in l) {
      delete l_convert.frozen;
    }

    if ('link_reverse' in l) {
      delete l_convert.link_reverse;
    } // if ( 'tooltip_text' in l_convert ) {
    //   delete l_convert.tooltip_text
    // }


    if ('display_unit' in l_convert) {
      l_convert.natural_unit = l_convert.display_unit;
      delete l_convert.display_unit;
    }

    if ('agregated_data_value' in l_convert) {
      l_convert.data_value = l_convert.agregated_data_value;
      delete l_convert.agregated_data_value;
    } // if (!('visible' in l_convert)) {
    //   l.visible = (source_node.visible || source_node.label_visible) && (target_node.visible || target_node.label_visible)
    // }
    // if (!('label_visible' in l_convert)) {
    //   l.label_visible = (source_node.visible || source_node.label_visible) && (target_node.visible || target_node.label_visible)
    // }


    if (l_convert.type === 'short_link_arrow') {
      l.curved = false;
      l.arrow = true;
    } else if (l_convert.type === 'bezier_link_arrow') {
      l.curved = true;
      l.arrow = true;
    } else if (l_convert.type === 'bezier_link_classic') {
      l.curved = true;
      l.arrow = false;
    }

    var attributes_to_remove = ['source', 'target', 'id', 'classif', 'title_length', 'raw_value', 'old_display_value', 'old_color', 'y_sd_label', 'x_sd_label', 'type'];

    for (var _attr2 in attributes_to_remove) {
      if (attributes_to_remove[_attr2] in l) {
        delete l[attributes_to_remove[_attr2]];
      }
    }

    if (data.version === '0.1') {
      var unit_index = l_convert.natural_unit ? units_names.indexOf(l_convert.natural_unit) : -1;

      if (l_convert.conv && unit_index !== -1) {
        var natural_conv = l_convert.conv[unit_index];
        l_convert.conv.splice(1, 0, natural_conv);
      }

      l.curved = true;
      l.curvature = 1;

      if (l_convert.text_same_color === true) {
        l.text_color = l.color;
      } else {
        l.text_color = 'white';
      }

      delete l_convert.text_same_color;

      if (target_node.x < source_node.x) {
        l.recycling = true;
      }
    } else if (!('curvature' in l)) {
      l.curvature = 0.5;
    }

    if (data.version === '0.2') {
      if (target_node.x < source_node.x) {
        l.recycling = true;
      }
    }

    if (data.version === '0.1' || data.version === '0.2') {
      if (l_convert.natural_unit) {
        if (l_convert.natural_unit.includes('tonne')) {
          l_convert.natural_unit = l_convert.natural_unit.replace('tonne', 't');

          if (l_convert.natural_unit === 'k t') {
            l_convert.natural_unit = 'kt';
          }
        }
      }

      delete l.tooltip_text;
    }

    if (!('text_color' in l) || l_convert.text_same_color === false) {
      l.text_color = 'black';
    } else if (l_convert.text_same_color === true) {
      l.text_color = l.color;
    } else if (l_convert.text_same_color === 'same_color') {
      l.text_color = l.color;
    }

    delete l_convert.text_same_color; // if (Object.values(data.tags_catalog).filter(tags_group => tags_group.group_name === 'Exchanges').length > 0) {
    //   if (!l.tags['Exchanges']) {
    //     l.tags['Exchanges'] = ['Other']
    //   }
    // }

    if (Object.entries(data.tags_catalog).filter(function (tags_group) {
      return tags_group[0] === 'flux_types';
    }).length > 0) {
      if (!l.tags['flux_types']) {
        if (l_convert.data && l_convert.data_value !== undefined) {
          l.tags['flux_types'] = ['initial_data', 'adjusted_data'];
          delete l_convert.data;
        } else {
          l.tags['flux_types'] = ['computed_data'];
        } // if (l_convert.unbounded) {
        //   l.tags['flux_types'] = ['unbounded']
        // }
        // if ('unbounded' in l_convert) {
        //   delete l_convert.unbounded
        // }


        if (l_convert.value === 0) {
          l.tags['flux_types'] = ['null_data'];
        }

        source_node.tags['flux_types'] = source_node.tags['flux_types'] ? (0, _toConsumableArray2.default)(new Set([].concat((0, _toConsumableArray2.default)(source_node.tags['flux_types']), (0, _toConsumableArray2.default)(l.tags['flux_types'])))) : (0, _toConsumableArray2.default)(l.tags['flux_types']);
        target_node.tags['flux_types'] = target_node.tags['flux_types'] ? (0, _toConsumableArray2.default)(new Set([].concat((0, _toConsumableArray2.default)(target_node.tags['flux_types']), (0, _toConsumableArray2.default)(l.tags['flux_types'])))) : (0, _toConsumableArray2.default)(l.tags['flux_types']);
      } else if (l.tags['flux_types'].includes('initial_data') && l_convert.data_value === undefined) {
        l.tags['flux_types'].splice(l.tags['flux_types'].indexOf('initial_data'));
      }
    }
  });

  if ('sankey_type' in data) {
    delete data.sankey_type;
  }

  if (display_style.filter_label === undefined) {
    display_style.filter_label = flux_max / 10;
  }

  if (data.version === '0.1') {
    units_names.splice(1, 0, 'natural');
  }

  data.version = '0.5';
};

exports.convert_data = convert_data;